import types from '../mutation-types';
import SocialPostsAPI from '../../api/socialPosts';

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
  },
  currentPage: 1,
  totalCount: 0,
};

export const getters = {
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  getPosts(_state) {
    return _state.records;
  },
  getMeta(_state) {
    return {
      count: _state.totalCount,
      currentPage: _state.currentPage,
      hasMore: _state.records.length < _state.totalCount,
    };
  },
};

export const actions = {
  get: async ({ commit }, { inboxId, page = 1 }) => {
    commit(types.SET_SOCIAL_POSTS_UI_FLAG, { isFetching: true });
    try {
      const response = await SocialPostsAPI.getByInbox(inboxId, page);
      const { payload, meta } = response.data;
      if (page === 1) {
        commit(types.SET_SOCIAL_POSTS, payload);
      } else {
        commit(types.APPEND_SOCIAL_POSTS, payload);
      }
      commit(types.SET_SOCIAL_POSTS_META, meta);
    } catch (error) {
      // Ignore error
    } finally {
      commit(types.SET_SOCIAL_POSTS_UI_FLAG, { isFetching: false });
    }
  },
  incrementCommentsCount: ({ commit }, { post }) => {
    commit(types.INCREMENT_POST_COMMENTS_COUNT, post.id);
    commit(types.INCREMENT_POST_UNSEEN_COUNT, post.id);
  },
  clearPosts: ({ commit }) => {
    commit(types.SET_SOCIAL_POSTS, []);
    commit(types.SET_SOCIAL_POSTS_META, { count: 0, current_page: 1 });
  },
};

export const mutations = {
  [types.SET_SOCIAL_POSTS_UI_FLAG](_state, data) {
    _state.uiFlags = { ..._state.uiFlags, ...data };
  },
  [types.SET_SOCIAL_POSTS](_state, data) {
    _state.records = data;
  },
  [types.APPEND_SOCIAL_POSTS](_state, data) {
    _state.records = [..._state.records, ...data];
  },
  [types.SET_SOCIAL_POSTS_META](_state, meta) {
    _state.totalCount = meta.count;
    _state.currentPage = meta.current_page;
  },
  [types.INCREMENT_POST_COMMENTS_COUNT](_state, postId) {
    const post = _state.records.find(p => p.id === postId);
    if (post) {
      post.comments_count = (post.comments_count || 0) + 1;
    }
  },
  [types.INCREMENT_POST_UNSEEN_COUNT](_state, postId) {
    const post = _state.records.find(p => p.id === postId);
    if (post) {
      post.unseen_count = (post.unseen_count || 0) + 1;
    }
  },
};

export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
};
